<template>
    <div>
        <b-row class="mb-2">
            <b-col>
                <b-button @click="add" class="btn btn-edit pull-right">{{Core.Definition.getDefinition('Nouveau rôle')}}</b-button>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'RoleContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
                if (this.$route.fullPath === window.Core.Definition.getDefinition('/systeme/roles/nouveau-role')) {
                    location.reload()
                } else {
                    this.$router.push(window.Core.Definition.getDefinition('/systeme/roles/nouveau-role'))
                }
            }
        }
    }
</script>
